export default "__VITE_ASSET__Bc2r3stN__"